import firmImg from './origin_firm.png';


export const assets = {
    firmImg
};
